import Store from 'store/store';
import pendingPromise from 'utils/pendingPromise';

let currentLocationRequest = 0;
Store.on('SET_USER_LOCATION', async (location, source, ticketType) => {
	let geo = Store.get().client.geo;
	let promise = geo.loading;
	if (!promise) {
		promise = pendingPromise();
		geo.set({ loading: promise }).now();
	}
	let requestId = ++currentLocationRequest;
	try {
		location = await (typeof location === 'function' ? location() : location);
	} catch (e) {
		// Error while getting location
		console.log('Error while getting location', e);
	}

	if (requestId !== currentLocationRequest) {
		return;
	}
	let storeGeo = Store.get().client.geo.set({ loading: null });
	if (!location || !location.lat || !location.lon) {
		return promise.resolve();
	}
	let newValue = { ...location };
	if (!newValue.countryCode && newValue.country) {
		newValue.countryCode = newValue.country;
		delete newValue.country;
	}
	storeGeo.set(newValue).now();
	Store.emit('USER_LOCATION_UPDATED', { geo: newValue, source, ticketType });
	promise.resolve(newValue);
});
